module.exports = __webpack_public_path__ + "img/Rectangulo_slider.8e771574.svg";